export default "__VITE_ASSET__QKObt6_n__"